import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import "./styles.scss";



const FormLabelCrud: FC<{ children: ReactNode }> = ({ children }): JSX.Element => {

    const { t } = useTranslation();

    return (
        <span className="custom_form_label_crud" >{typeof children === 'string' ? t(children) : children}</span>
    )
}

export default FormLabelCrud;